// Mock data pour le site BOUHDEL

export const mockData = {
  company: {
    name: "Bouhdel",
    tagline: "Construire votre rêve",
    description: "Constructeur de maisons individuelles sur mesure dans le sud de la France depuis plus de 20 ans",
    slogan: "Votre projet, notre expertise, votre maison",
    phone: "+33 4 90 47 15 78",
    email: "contact@bouhdel.com"
  },

  // Agences Bouhdel - 4 implantations dans le sud
  agencies: [
    {
      id: 1,
      name: "Arles",
      address: "8 rue Gaspard Monge",
      zipCode: "13200",
      city: "Arles",
      phone: "+33 4 90 96 15 22",
      email: "arles@bouhdel.com",
      image: "/assets/photos/agences/arles.webp",
      alt: "Conseillère de l'agence d'Arles à son bureau, devant le mur des plans de lotissements du secteur",
      coordinates: {
        lat: 43.6768,
        lng: 4.6279
      },
      hours: {
        weekdays: "9h-13h | 14h-18h",
        saturday: "Fermé",
        sunday: "Fermé"
      },
      team: {
        manager: "Laurent Mercier",
        salesCount: 3,
        technicalCount: 2
      },
      coverageArea: ["Arles", "Tarascon", "Beaucaire", "Saint-Martin-de-Crau", "Fontvieille"],
      description: "Notre agence d'Arles vous accueille au cœur de la ville historique pour tous vos projets de construction."
    },
    {
      id: 2,
      name: "Châteaurenard",
      address: "638 av. de la Libération Parc des Beaumes",
      zipCode: "13160",
      city: "Châteaurenard",
      phone: "+33 4 90 94 28 35",
      email: "chateaurenard@bouhdel.com",
      image: "/assets/photos/agences/chateaurenard.webp",
      alt: "Conseiller de l'agence de Châteaurenard au téléphone à son bureau, devant le kakémono Bouhdel",
      coordinates: {
        lat: 43.8843,
        lng: 4.8530
      },
      hours: {
        weekdays: "9h-13h | 14h-18h",
        saturday: "Fermé",
        sunday: "Fermé"
      },
      team: {
        manager: "Sophie Blanchard",
        salesCount: 2,
        technicalCount: 2
      },
      coverageArea: ["Châteaurenard", "Noves", "Eyragues", "Rognonas", "Barbentane"],
      description: "L'agence de Châteaurenard accompagne vos projets dans le secteur des Alpilles et la vallée de la Durance."
    },
    {
      id: 3,
      name: "Caissargues",
      address: "20 av. de la Dame zone euro 2000",
      zipCode: "30132",
      city: "Caissargues",
      phone: "+33 4 66 38 45 78",
      email: "caissargues@bouhdel.com",
      image: "/assets/photos/agences/caissargues00.webp",
      alt: "Conseillère de l'agence de Caissargues au téléphone, carnet de rendez-vous ouvert devant elle",
      coordinates: {
        lat: 43.7979,
        lng: 4.3847
      },
      hours: {
        weekdays: "9h-13h | 14h-18h",
        saturday: "Fermé",
        sunday: "Fermé"
      },
      team: {
        manager: "Marc Dubois",
        salesCount: 4,
        technicalCount: 3
      },
      coverageArea: ["Nîmes", "Caissargues", "Milhaud", "Uchaud", "Manduel", "Bouillargues"],
      description: "Notre agence de Caissargues rayonne sur l'agglomération nîmoise et la Vistrenque."
    },
    {
      id: 4,
      name: "Fos-sur-Mer",
      address: "Chemin de Guigonnet",
      zipCode: "13270",
      city: "Fos-sur-Mer",
      phone: "+33 4 42 05 67 89",
      email: "fos@bouhdel.com",
      image: "/assets/photos/agences/fos.webp",
      alt: "Bâtiment d'agence contemporain en pierre et verre, entouré d'oliviers et de plantes méditerranéennes",
      coordinates: {
        lat: 43.4402,
        lng: 4.9441
      },
      hours: {
        weekdays: "9h-13h | 14h-18h",
        saturday: "Fermé",
        sunday: "Fermé"
      },
      team: {
        manager: "Élodie Martin",
        salesCount: 3,
        technicalCount: 2
      },
      coverageArea: ["Fos-sur-Mer", "Port-Saint-Louis-du-Rhône", "Istres", "Miramas", "Saint-Mitre-les-Remparts"],
      description: "L'agence de Fos-sur-Mer vous accompagne sur le secteur Ouest Étang de Berre et la Camargue industrielle."
    }
  ],

  // Services - Parcours client complet A à Z
  services: [
    {
      id: 1,
      title: "Aide à la recherche du terrain",
      description: "Nous vous accompagnons dans la recherche du terrain idéal selon vos critères : situation, superficie, viabilisation. Notre réseau et notre connaissance du territoire vous font gagner du temps.",
      icon: "MapPin",
      details: [
        "Analyse de vos besoins et budget",
        "Recherche active dans notre réseau",
        "Vérification PLU et constructibilité",
        "Négociation et accompagnement achat"
      ]
    },
    {
      id: 2,
      title: "Création des plans & modélisation 3D",
      description: "Maison 100% personnalisable : nos dessinateurs créent les plans sur-mesure adaptés à votre mode de vie, optimisent les espaces et vous proposent une visualisation 3D réaliste.",
      icon: "PenTool",
      details: [
        "Plans personnalisés à 100%",
        "Optimisation des espaces et circulation",
        "Perspectives 3D photo-réalistes",
        "Modifications illimitées jusqu'à validation"
      ]
    },
    {
      id: 3,
      title: "Montage administratif & financement",
      description: "Nous gérons toutes les démarches : permis de construire, raccordements, assurances. Nous vous mettons en relation avec nos partenaires bancaires pour optimiser votre financement.",
      icon: "FileText",
      details: [
        "Dépôt et suivi permis de construire",
        "Raccordements (eau, électricité, assainissement)",
        "Montage dossier financement",
        "Assurance dommages-ouvrage incluse"
      ]
    },
    {
      id: 4,
      title: "Suivi de chantier professionnel",
      description: "Un conducteur de travaux dédié assure le suivi quotidien, coordonne les artisans qualifiés et vous tient informé à chaque étape clé. Visites régulières planifiées.",
      icon: "HardHat",
      details: [
        "Conducteur de travaux dédié",
        "Planning détaillé et suivi en temps réel",
        "Coordination des corps de métier",
        "Visites de chantier programmées"
      ]
    },
    {
      id: 5,
      title: "Garanties & assurances",
      description: "Bénéficiez de toutes les garanties légales pour votre tranquillité : garantie décennale, garantie de parfait achèvement, assurance dommages-ouvrage souscrite avant ouverture du chantier.",
      icon: "Shield",
      details: [
        "Garantie décennale 10 ans",
        "Garantie parfait achèvement 1 an",
        "Assurance dommages-ouvrage",
        "Garanties constructeur certifié"
      ]
    },
    {
      id: 6,
      title: "Remise des clés",
      description: "Réception des travaux en votre présence, vérification minutieuse, levée des réserves éventuelles et remise des clés de votre maison. Nous restons à vos côtés même après la livraison.",
      icon: "Key",
      details: [
        "Visite de pré-réception",
        "Réception officielle des travaux",
        "Levée des réserves sous 8 jours",
        "SAV et suivi post-livraison"
      ]
    }
  ],


  // Valeurs - ADN de l'entreprise
  values: [
    {
      id: 1,
      title: "20+ ans d'expertise",
      description: "Plus de deux décennies d'expérience dans la construction de maisons individuelles sur mesure dans le sud de la France. Un savoir-faire reconnu.",
      icon: "Award"
    },
    {
      id: 2,
      title: "Proximité humaine",
      description: "Un accompagnement personnalisé avec un interlocuteur dédié de A à Z. La relation client est au cœur de chaque projet, nous sommes à vos côtés à chaque étape.",
      icon: "Users"
    },
    {
      id: 3,
      title: "Qualité artisanale",
      description: "Des matériaux de qualité, des artisans qualifiés locaux, un contrôle rigoureux à chaque étape. Le professionnalisme de nos équipes fait la différence.",
      icon: "CheckCircle"
    },
    {
      id: 4,
      title: "Sérieux et engagement",
      description: "Respect des délais, transparence sur les coûts, suivi de chantier professionnel. Nous tenons nos promesses pour votre tranquillité d'esprit.",
      icon: "Clock"
    }
  ],

  // Projets réalisés - 6 projets max
  projects: [
    {
      id: 1,
      title: "Villa Contemporaine Arles Centre",
      description: "Maison contemporaine de 160m² en plein centre-ville, garage double et terrasse 50m².",
      image: "/assets/photos/realisations/DSC06341.webp",
      alt: "Maison à étage en enduit clair et toiture en tuiles, jardin clos avec portique en bois et jeune olivier",
      tags: ["Contemporaine", "Centre-ville", "Garage"],
      agency: "Arles",
      surface: "160m²",
      year: "2024"
    },
    {
      id: 2,
      title: "Mas Provençal Fontvieille",
      description: "Authentique mas de 180m² alliant charme traditionnel et confort moderne avec piscine.",
      image: "/assets/photos/realisations/DSC06695.webp",
      alt: "Maison à étage en enduit crème avec garage accolé, portails en aluminium ajouré et piliers en pierre",
      tags: ["Traditionnelle", "Piscine", "Charme"],
      agency: "Arles",
      surface: "180m²",
      year: "2023"
    },
    {
      id: 3,
      title: "Maison Familiale Noves",
      description: "Plain-pied de 120m² idéal pour une famille, jardin arboré 800m² et terrasse couverte.",
      image: "/assets/photos/realisations/DSC06346.webp",
      alt: "Maison à étage aux menuiseries anthracite, garage accolé à toiture plate et jardin de façade planté derrière une clôture",
      tags: ["Plain-pied", "Familiale", "Jardin"],
      agency: "Châteaurenard",
      surface: "120m²",
      year: "2024"
    },
    {
      id: 4,
      title: "Villa Les Alpilles Eyragues",
      description: "Maison de 190m² avec vue panoramique sur les Alpilles, piscine à débordement.",
      image: "/assets/photos/realisations/DSC06354.webp",
      alt: "Maison en enduit clair à toiture de tuiles, entrée couverte et allée d'accès fermée par un portail",
      tags: ["Luxe", "Piscine", "Vue Alpilles"],
      agency: "Châteaurenard",
      surface: "190m²",
      year: "2023"
    },
    {
      id: 5,
      title: "Villa Contemporaine Milhaud",
      description: "Maison d'architecte de 200m² aux lignes épurées, baies vitrées XXL et jardin paysager.",
      image: "/assets/photos/realisations/DSC06363.webp",
      alt: "Maison provençale à volets vert amande, muret en pierre sèche, oliviers et cyprès derrière un portail coulissant",
      tags: ["Architecte", "Baies vitrées", "Design"],
      agency: "Caissargues",
      surface: "200m²",
      year: "2024"
    },
    {
      id: 6,
      title: "Villa Méditerranéenne Port-Saint-Louis",
      description: "Maison de 155m² inspirée de l'architecture méditerranéenne, à 800m de la mer.",
      image: "/assets/photos/realisations/DSC06677.webp",
      alt: "Maison à étage en enduit crème avec deux garages, cour goudronnée et grand pin en arrière-plan",
      tags: ["Méditerranéenne", "Proche mer", "Terrasse"],
      agency: "Fos-sur-Mer",
      surface: "155m²",
      year: "2024"
    }
  ],

  // Témoignages clients - 3 maximum
  testimonials: [
    {
      id: 1,
      name: "jmarc natali",
      location: "Local Guide",
      date: "Janvier 2025",
      content: "Maison Bouhdel travaille bien. Les projets sont bien étudiés, la réalisation par des artisans bien pilotée. Délai promis respecté. Vigilance : Il ne faut pas sortir du contrat CCMI signé avec le constructeur.",
      rating: 5,
      source: "google"
    },
    {
      id: 2,
      name: "jegu olivi",
      location: "Client Bouhdel",
      date: "Février 2026",
      content: "Un grand merci à toute l'équipe de la société Bouhdel qui m'a permis de construire un joli cocon pour mes enfants et moi ! Tous le monde est à l'écoute du client, des prestataires de qualité et très sérieux.",
      rating: 5,
      source: "google"
    },
    {
      id: 3,
      name: "YoannM",
      location: "Client Bouhdel",
      date: "Décembre 2025",
      content: "Nous avons choisi Bouhdel pour la construction de notre maison et nous en sommes ravis. Merci à Jean et ses collaborateurs pour leur disponibilité, ils ont été à notre écoute pour mener à bien notre projet.",
      rating: 5,
      source: "google"
    },
    {
      id: 4,
      name: "Sabrina Rebai",
      location: "Cliente Bouhdel",
      date: "Avril 2022",
      content: "Ravis d'avoir choisi l'entreprise Bouhdel pour notre projet. Très satisfait du résultat. Ils ont su répondre à toutes nos attentes. Un commercial (Mr Boucherf) qui a su nous accompagner du début à la fin en se montrant à l'écoute. Très professionnel.",
      rating: 5,
      source: "google"
    },
    {
      id: 5,
      name: "Alexandre Gaafer",
      location: "Client Bouhdel",
      date: "Octobre 2023",
      content: "Une très très bonne expérience avec l'entreprise Bouhdel du début jusqu'à la fin. Une approche très agréable et appréciable avec Johann Hamel, Céline et toute l'équipe. Je recommande vivement.",
      rating: 5,
      source: "google"
    }
  ],


  // Statistiques
  stats: [
    { label: "Ans d'expérience", value: "20+", icon: "Award" },
    { label: "Maisons construites", value: "4000+", icon: "Home" },
    { label: "Clients satisfaits", value: "100%", icon: "ThumbsUp" },
    { label: "Ans de Garantie", value: "10+", icon: "Shield" }
  ],

  // Histoire de l'entreprise
  history: {
    founded: "2003",
    founders: "Les trois frères Bouhdel",
    origin: "Arles, Provence",
    tagline: "Une histoire de famille, un savoir-faire provençal",
    story: "L'aventure Bouhdel commence au début des années 2000, quand trois frères unis par la même passion de la construction décident de créer leur propre entreprise à Arles. Forts de leur expérience sur les chantiers du sud de la France et de leur connaissance intime du territoire provençal, ils posent les fondations d'une entreprise familiale qui allait devenir l'un des constructeurs de référence de la région.",
    milestones: [
      { year: "2003", title: "Création de l'entreprise", description: "Les trois frères Bouhdel fondent l'entreprise à Arles, avec la vision de construire des maisons de qualité en Provence." },
      { year: "2006", title: "Premières livraisons", description: "Les premiers clients reçoivent les clés de leur maison. Le bouche-à-oreille commence à fonctionner grâce à la qualité du travail." },
      { year: "2010", title: "Ouverture de l'agence de Châteaurenard", description: "Le succès grandissant pousse l'entreprise à ouvrir une deuxième agence pour couvrir le secteur des Alpilles." },
      { year: "2014", title: "Expansion vers le Gard", description: "Ouverture de l'agence de Caissargues pour accompagner les projets dans l'agglomération nîmoise." },
      { year: "2018", title: "4ème agence à Fos-sur-Mer", description: "Bouhdel étend sa couverture vers l'ouest de l'Étang de Berre avec une nouvelle implantation." },
      { year: "2024", title: "Cap des 4000 maisons", description: "Plus de 4000 familles nous ont fait confiance pour construire leur maison. Un cap symbolique qui témoigne de notre engagement." }
    ],
  },

  // Équipe - Vrais membres de l'agence
  team: [
    {
      id: 1,
      name: "Khalid Bouhdel",
      role: "Co-fondateur & Directeur Général",
      description: "Porteur de la vision stratégique et du développement des Maisons Bouhdel depuis 2003. Khalid veille à la pérennité et à l'indépendance de l'entreprise familiale.",
      color: "var(--brand-primary)",
      avatar: "K"
    },
    {
      id: 2,
      name: "Tarik Bouhdel",
      role: "Co-fondateur & Directeur Technique",
      description: "Garant de l'excellence constructive. Tarik coordonne les bureaux d'études et s'assure que chaque chantier respecte les normes et exigences de qualité du groupe.",
      color: "var(--green-dark)",
      avatar: "T"
    },
    {
      id: 3,
      name: "Morad Bouhdel",
      role: "Co-fondateur & Directeur des Opérations",
      description: "Supervise la dynamique commerciale et le réseau des 4 agences. Morad met un point d'honneur à préserver la proximité avec chaque famille.",
      color: "var(--green-light)",
      avatar: "M"
    },
    {
      id: 4,
      name: "Antoine",
      role: "Responsable Commercial",
      description: "Expert en accompagnement client, Antoine vous guide dans toutes les étapes de votre projet avec passion et professionnalisme.",
      color: "#4285F4",
      avatar: "A"
    },
    {
      id: 5,
      name: "Valentin",
      role: "Conducteur de Travaux",
      description: "Valentin supervise chaque chantier avec rigueur pour garantir la qualité et le respect des délais.",
      color: "#34A853",
      avatar: "V"
    },
    {
      id: 6,
      name: "Jean",
      role: "Responsable Technique",
      description: "Fort de son expertise technique, Jean assure la conformité et la qualité de chaque construction.",
      color: "#FBBC05",
      avatar: "J"
    },
    {
      id: 7,
      name: "Céline",
      role: "Assistante de Direction",
      description: "Céline est votre premier contact. Elle coordonne les rendez-vous et assure le suivi administratif de votre dossier.",
      color: "#EA4335",
      avatar: "C"
    }
  ],

  // Données CCMI
  ccmi: {
    title: "Le CCMI : votre bouclier pour construire sereinement",
    subtitle: "Comprendre le contrat qui protège votre projet, en toute transparence",
    intro: "Le Contrat de Construction de Maison Individuelle (CCMI), encadré par la loi du 19 décembre 1990, est le cadre juridique le plus protecteur pour les particuliers qui font construire. En choisissant Bouhdel, constructeur sous CCMI, vous bénéficiez de garanties financières, de délais contractuels et d'un prix ferme qui sécurisent chaque étape de votre projet.",
    
    // Scénario humain
    scenario: {
      title: "Marc et Sophie construisent leur maison",
      steps: [
        { emoji: "🤝", label: "Signature", text: "Le prix est fixé, le délai est inscrit au contrat. Pas de mauvaise surprise." },
        { emoji: "🏗️", label: "Chantier", text: "Les paiements suivent l'avancement réel des travaux. Un interlocuteur unique coordonne tout." },
        { emoji: "🔑", label: "Livraison", text: "Les clés sont remises dans les temps. Les garanties prennent le relais pour 10 ans." },
        { emoji: "😌", label: "Sérénité", text: "En cas de souci ? La garantie décennale couvre les défauts. Leur investissement est protégé." }
      ]
    },

    // 9 garanties complètes (incluant DO, parfait achèvement, biennale)
    guarantees: [
      {
        title: "Prix ferme et définitif",
        description: "Le prix global est fixé à la signature. Il ne peut être révisé que selon l'indice du coût de la construction (ICC), jamais arbitrairement. Vous savez exactement ce que vous allez payer.",
        icon: "Euro",
        category: "financial"
      },
      {
        title: "Délai de livraison garanti",
        description: "La date de livraison est inscrite au contrat. En cas de retard imputable au constructeur, des pénalités journalières sont prévues en votre faveur.",
        icon: "Calendar",
        category: "financial"
      },
      {
        title: "Garantie de livraison",
        description: "C'est le cœur du CCMI. Un organisme financier garant s'engage à achever votre maison au prix et dans les délais convenus, même si le constructeur fait défaut (dépôt de bilan, etc.).",
        icon: "ShieldCheck",
        category: "financial"
      },
      {
        title: "Paiement échelonné et réglementé",
        description: "Vos paiements sont strictement calés sur l'avancement réel des travaux, selon un échéancier légal précis. Vous ne payez jamais plus que ce qui est construit.",
        icon: "CreditCard",
        category: "financial"
      },
      {
        title: "Droit de rétractation (10 jours)",
        description: "Après réception du contrat signé par lettre recommandée, vous disposez de 10 jours calendaires pour vous rétracter sans motif ni pénalité.",
        icon: "RotateCcw",
        category: "legal"
      },
      {
        title: "Conditions suspensives",
        description: "Le contrat est conditionné à l'obtention de votre prêt immobilier et de votre permis de construire. Si l'une de ces conditions n'est pas remplie, le contrat est annulé sans pénalité.",
        icon: "FileCheck",
        category: "legal"
      },
      {
        title: "Garantie de parfait achèvement (1 an)",
        description: "Pendant 1 an après la réception, le constructeur doit réparer tous les désordres signalés, qu'ils soient esthétiques ou fonctionnels. Un simple courrier recommandé suffit.",
        icon: "Wrench",
        category: "afterSale"
      },
      {
        title: "Garantie biennale (2 ans)",
        description: "Pendant 2 ans, les éléments d'équipement dissociables du bâti (volets, robinetterie, radiateurs, portes intérieures…) sont couverts en cas de dysfonctionnement.",
        icon: "Settings",
        category: "afterSale"
      },
      {
        title: "Garantie décennale (10 ans)",
        description: "Votre maison est protégée pendant 10 ans contre les vices et malfaçons affectant la solidité de l'ouvrage ou le rendant inhabitable (fissures structurelles, infiltrations, etc.).",
        icon: "Shield",
        category: "afterSale"
      }
    ],

    // Grille d'appels de fonds légale
    paymentSchedule: [
      { stage: "Ouverture de chantier", percent: 15, description: "Premiers terrassements et fondations" },
      { stage: "Achèvement des fondations", percent: 25, description: "Fondations terminées et dalle coulée" },
      { stage: "Élévation des murs", percent: 40, description: "Murs montés, charpente posée" },
      { stage: "Mise hors d'eau", percent: 60, description: "Toiture terminée, la maison est étanche" },
      { stage: "Mise hors d'air", percent: 75, description: "Fenêtres et portes posées" },
      { stage: "Achèvement des travaux", percent: 95, description: "Finitions, peintures, équipements" },
      { stage: "Remise des clés", percent: 100, description: "Réception et solde à la livraison" }
    ],

    // Comparatif honnête : CCMI vs Maître d'œuvre vs Auto-construction
    comparison: [
      { criteria: "Prix fixe et garanti", ccmi: true, mo: false, auto: false },
      { criteria: "Garantie de livraison à prix convenu", ccmi: true, mo: false, auto: false },
      { criteria: "Délais contractuels avec pénalités", ccmi: true, mo: "partial", auto: false },
      { criteria: "Assurance dommages-ouvrage facilitée", ccmi: true, mo: true, auto: true },
      { criteria: "Droit de rétractation 10 jours", ccmi: true, mo: false, auto: false },
      { criteria: "Interlocuteur unique", ccmi: true, mo: true, auto: false },
      { criteria: "Garantie décennale", ccmi: true, mo: true, auto: true },
      { criteria: "Garantie parfait achèvement (1 an)", ccmi: true, mo: "partial", auto: false },
      { criteria: "Garantie biennale (2 ans)", ccmi: true, mo: true, auto: true },
      { criteria: "Conditions suspensives (prêt, PC)", ccmi: true, mo: false, auto: false }
    ],

    // Assurance Dommages-Ouvrage : section dédiée
    dommagesOuvrage: {
      title: "L'assurance Dommages-Ouvrage (DO)",
      subtitle: "Obligatoire pour le client, facilitée par le CCMI",
      text: "L'assurance Dommages-Ouvrage est une obligation légale pour tout maître d'ouvrage (vous, le client). Elle permet d'être indemnisé rapidement en cas de sinistre relevant de la garantie décennale, sans attendre qu'un tribunal désigne le responsable. Chez Bouhdel, nous vous accompagnons dans cette démarche et travaillons avec des partenaires assureurs pour faciliter sa souscription.",
      keyPoints: [
        "Obligatoire pour le client (pas pour le constructeur)",
        "Indemnisation rapide sans recherche de responsabilité",
        "Couvre les sinistres relevant de la décennale",
        "Facilite la revente du bien (exigée par les notaires)"
      ]
    },

    // FAQ avec réponses honnêtes
    faq: [
      {
        question: "Le CCMI coûte-t-il plus cher qu'un maître d'œuvre ?",
        answer: "Oui, généralement le coût global d'un CCMI est légèrement supérieur à celui d'un projet piloté par un maître d'œuvre ou un architecte. C'est le prix de la sécurité : garantie de livraison, prix ferme, interlocuteur unique. Chez Bouhdel, nous estimons que la tranquillité d'esprit sur votre plus grand investissement n'a pas de prix — mais nous vous invitons à comparer en toute connaissance de cause."
      },
      {
        question: "Puis-je modifier les plans en cours de chantier ?",
        answer: "C'est possible, mais encadré. Toute modification en cours de chantier se fait via un avenant au contrat, qui peut engendrer des coûts supplémentaires et des délais. C'est pourquoi nous passons beaucoup de temps en amont sur la conception : pour que le projet vous corresponde parfaitement avant le premier coup de pelle."
      },
      {
        question: "Qui souscrit l'assurance Dommages-Ouvrage ?",
        answer: "La loi impose que l'assurance Dommages-Ouvrage soit au nom du client (maître d'ouvrage). Pour vous simplifier la vie, chez Bouhdel, cette assurance est directement incluse dans votre contrat CCMI. Nous prenons en charge toutes les démarches de souscription pour vous, sans frais cachés ni mauvaise surprise sur votre budget."
      },
      {
        question: "Quelle est la différence entre garantie décennale et Dommages-Ouvrage ?",
        answer: "La garantie décennale est l'assurance du constructeur : elle couvre les défauts graves pendant 10 ans. La Dommages-Ouvrage est votre assurance à vous : elle vous permet d'être indemnisé rapidement sans attendre que la justice détermine qui est responsable. Les deux sont complémentaires."
      },
      {
        question: "Le tableau comparatif est-il objectif ?",
        answer: "Nous avons voulu être honnêtes. Le CCMI offre plus de sécurité, mais un maître d'œuvre ou un architecte offre plus de flexibilité et parfois un coût inférieur. C'est une question de priorités : si la sécurité financière est votre critère n°1, le CCMI est imbattable. Si vous cherchez une personnalisation maximale et êtes prêt à gérer plus de complexité, un maître d'œuvre peut convenir."
      }
    ]
  },
  // Données RE2020
  re2020: {
    title: "La RE2020 en toute transparence",
    subtitle: "Comprendre la nouvelle norme : ses bénéfices réels, ses limites, et ce que ça change pour vous",
    intro: "Depuis le 1er janvier 2022, la RE2020 remplace la RT2012 et fixe de nouvelles exigences ambitieuses pour les constructions neuves. Chez Bouhdel, 100% de nos maisons sont conformes à cette norme. Mais plutôt que de vous vendre un rêve, nous préférons vous l'expliquer honnêtement.",

    // Chiffres clés en contexte
    keyFigures: [
      { value: "2022", label: "En vigueur depuis", detail: "Remplace la RT2012 après 10 ans" },
      { value: "-30%", label: "Consommation énergie", detail: "Par rapport à la RT2012 (objectif théorique)" },
      { value: "+5 à 10%", label: "Surcoût estimé", detail: "Par rapport à une construction RT2012" },
      { value: "A ou B", label: "DPE garanti", detail: "Classement énergétique de votre bien" }
    ],

    // 3 piliers enrichis avec nuances
    pillars: [
      {
        title: "Sobriété énergétique",
        description: "La RE2020 impose une réduction significative de la consommation d'énergie primaire grâce à une isolation renforcée, des menuiseries performantes et des équipements à haut rendement (pompe à chaleur, chauffe-eau thermodynamique).",
        icon: "Zap",
        benefits: ["Factures d'énergie réduites de 30 à 50% vs maison ancienne", "Isolation thermique renforcée (murs, planchers, toiture)", "Équipements à haut rendement énergétique"],
        caveat: "L'objectif de -30% est un calcul sur logiciel (moteur de calcul réglementaire). Les économies réelles dépendent de vos habitudes de vie : température de consigne, aération, nombre d'occupants. Une maison RE2020 chauffée à 23°C consommera plus qu'une maison RT2012 chauffée à 19°C."
      },
      {
        title: "Réduction de l'empreinte carbone",
        description: "La norme impose une Analyse du Cycle de Vie (ACV) dynamique : chaque matériau est évalué de sa fabrication à sa fin de vie. L'objectif est de réduire progressivement l'impact carbone de la construction, en favorisant les matériaux biosourcés.",
        icon: "Leaf",
        benefits: ["Matériaux durables et responsables", "Bilan carbone maîtrisé sur 50 ans", "Valorisation de votre bien à la revente (DPE A/B)"],
        caveat: "La filière des matériaux biosourcés (bois, chanvre, paille) n'est pas encore dimensionnée pour répondre à la demande. Cela peut entraîner des tensions sur les prix et les délais d'approvisionnement, et parfois des importations qui nuancent le bilan carbone."
      },
      {
        title: "Confort d'été",
        description: "La RE2020 introduit un indicateur inédit : les Degrés-Heures d'inconfort (DH). Elle impose une conception bioclimatique (orientation, débords de toit, volets, ventilation) pour limiter la surchauffe estivale sans recourir systématiquement à la climatisation.",
        icon: "Sun",
        benefits: ["Protection renforcée contre les canicules", "Ventilation naturelle optimisée", "Réduction du besoin de climatisation"],
        caveat: "Le calcul des Degrés-Heures est un modèle théorique. Avec la multiplication des dômes de chaleur, certains experts craignent un \"effet thermos\" : une maison très isolée qui peine à évacuer la chaleur une fois qu'elle y est entrée. Chez Bouhdel, nous compensons par des casquettes solaires, une ventilation traversante et des volets à lames orientables."
      }
    ],

    // Comparaison RT2012 vs RE2020
    comparison: [
      { criteria: "Consommation d'énergie primaire", rt2012: "50 kWh/m²/an max", re2020: "Réduit de ~30%" },
      { criteria: "Empreinte carbone", rt2012: "Non mesurée", re2020: "ACV dynamique sur 50 ans" },
      { criteria: "Confort d'été", rt2012: "Tic (indicateur simple)", re2020: "Degrés-Heures (DH)" },
      { criteria: "Matériaux biosourcés", rt2012: "Pas d'exigence", re2020: "Encouragés (seuils carbone)" },
      { criteria: "Énergies renouvelables", rt2012: "Encouragées", re2020: "Quasi-obligatoires" },
      { criteria: "DPE typique", rt2012: "B à C", re2020: "A à B" }
    ],

    // Avantages client (nuancés)
    clientBenefits: [
      { 
        title: "Factures allégées", 
        description: "Une maison RE2020 consomme significativement moins d'énergie qu'une maison ancienne. L'économie dépend de vos habitudes, mais sur 20 ans elle peut atteindre plusieurs dizaines de milliers d'euros.",
        icon: "Wallet"
      },
      { 
        title: "Confort toute l'année", 
        description: "Mieux isolée, mieux ventilée, conçue pour le climat provençal : votre maison maintient une température agréable avec moins d'énergie, été comme hiver.",
        icon: "ThermometerSun"
      },
      { 
        title: "Valeur patrimoniale", 
        description: "Un DPE classé A ou B est un argument de vente puissant. Alors que les passoires thermiques se déprécient, votre bien RE2020 se valorisera dans le temps.",
        icon: "TrendingUp"
      },
      { 
        title: "Engagement concret", 
        description: "Le secteur du bâtiment représente 25% des émissions de CO₂ en France. Construire RE2020, c'est contribuer directement à l'effort climatique — même si la norme ne concerne que le neuf.",
        icon: "Heart"
      }
    ],

    // Section transparence : ce qu'on ne vous dit pas ailleurs
    transparency: [
      {
        title: "Oui, ça coûte plus cher",
        text: "La RE2020 entraîne un surcoût de 5 à 10% par rapport à une construction RT2012. Pompe à chaleur, isolation renforcée, études thermiques poussées : tout cela a un prix. Chez Bouhdel, nous intégrons ces coûts de manière transparente dans nos devis CCMI — le prix est ferme, pas de surprise.",
        icon: "Euro"
      },
      {
        title: "L'effet thermos est un vrai sujet",
        text: "Une maison très isolée qui capte trop de chaleur peut peiner à la restituer. C'est pourquoi nous ne nous contentons pas de \"cocher les cases\" réglementaires : nous concevons chaque maison en fonction de son orientation, du climat local (Provence oblige) et de votre mode de vie. Volets, brise-soleil, ventilation nocturne : les solutions existent, encore faut-il les penser dès la conception.",
        icon: "AlertTriangle"
      },
      {
        title: "La norme ne concerne que le neuf",
        text: "La RE2020 ne s'applique qu'aux constructions neuves, qui représentent environ 1% du parc immobilier par an. Le vrai enjeu énergétique de la France, ce sont les 35 millions de logements existants. Construire neuf en RE2020 est un choix vertueux, mais ne résout pas le problème global à lui seul.",
        icon: "Info"
      }
    ],

    // FAQ honnête
    faq: [
      {
        question: "En combien de temps le surcoût RE2020 est-il amorti ?",
        answer: "Cela dépend de votre consommation et du prix de l'énergie. Pour une maison de 100m² en Provence, le surcoût RE2020 (vs RT2012) est estimé entre 8 000€ et 15 000€. Avec des factures d'énergie réduites de 500 à 800€/an, l'amortissement se situe entre 10 et 20 ans. Mais la vraie plus-value est patrimoniale : un DPE A/B protège votre bien contre la dépréciation."
      },
      {
        question: "Ma maison RE2020 peut-elle devenir un \"thermos\" en été ?",
        answer: "C'est un risque si la conception est bâclée. Une isolation parfaite sans stratégie de ventilation et de protection solaire, c'est comme un thermos : ça garde le chaud comme le froid. Chez Bouhdel, chaque projet intègre dès la conception des solutions bioclimatiques adaptées au climat provençal (casquettes solaires, ventilation traversante, volets orientables). Nous ne faisons pas du \"RE2020 au rabais\"."
      },
      {
        question: "Les matériaux biosourcés sont-ils vraiment écologiques ?",
        answer: "Quand ils sont locaux, oui. Le bois de structure français (Douglas, épicéa) a un bilan carbone excellent. Le problème surgit quand la demande dépasse l'offre locale et qu'on importe du bois de loin. Chez Bouhdel, nous privilégions les filières courtes et les fournisseurs régionaux. Quand le bois n'est pas pertinent (sol, fondations), nous utilisons du béton bas carbone."
      },
      {
        question: "La RE2020 rend-elle la construction inaccessible financièrement ?",
        answer: "C'est le reproche le plus fréquent, et il est en partie fondé. Le surcoût de 5 à 10% pèse sur le budget total, surtout avec des taux d'intérêt élevés. Chez Bouhdel, nous travaillons avec des courtiers partenaires pour optimiser votre plan de financement, et notre CCMI fixe le prix dès la signature — aucune dérive n'est possible. Le surcoût RE2020 est un investissement, pas une charge sèche."
      },
      {
        question: "Pourquoi la RE2020 ne s'applique-t-elle pas à la rénovation ?",
        answer: "La RE2020 est une réglementation de construction neuve. Pour la rénovation, ce sont les dispositifs MaPrimeRénov', les CEE et le DPE qui encadrent les travaux. C'est un choix politique : imposer des standards très élevés au neuf tout en incitant (sans obliger) à rénover l'ancien. L'un n'empêche pas l'autre, mais on comprend la frustration."
      }
    ]
  },

  // Projets supplémentaires pour la galerie complète
  allProjects: [
    {
      id: 7,
      title: "Villa Moderne Saint-Martin-de-Crau",
      description: "Maison de plain-pied de 140m² avec toiture terrasse, lignes contemporaines et grand jardin paysager.",
      image: "/assets/photos/realisations/DSC06341.webp",
      alt: "Maison à étage en enduit clair et toiture en tuiles, jardin clos avec portique en bois et jeune olivier",
      tags: ["Plain-pied", "Toiture terrasse", "Moderne"],
      agency: "Arles",
      surface: "140m²",
      year: "2023"
    },
    {
      id: 8,
      title: "Maison Traditionnelle Beaucaire",
      description: "Villa de style provençal de 175m² avec tuiles canal, volets battants et jardin méditerranéen.",
      image: "/assets/photos/realisations/DSC06695.webp",
      alt: "Maison à étage en enduit crème avec garage accolé, portails en aluminium ajouré et piliers en pierre",
      tags: ["Traditionnelle", "Provençale", "Charme"],
      agency: "Arles",
      surface: "175m²",
      year: "2022"
    },
    {
      id: 9,
      title: "Villa Design Rognonas",
      description: "Maison d'architecte R+1 de 210m² avec double garage, suite parentale et piscine à débordement.",
      image: "/assets/photos/realisations/DSC06354.webp",
      alt: "Maison en enduit clair à toiture de tuiles, entrée couverte et allée d'accès fermée par un portail",
      tags: ["Design", "Piscine", "R+1"],
      agency: "Châteaurenard",
      surface: "210m²",
      year: "2023"
    },
    {
      id: 10,
      title: "Maison Compacte Manduel",
      description: "Maison de 95m² optimisée pour primo-accédants, 3 chambres, jardin et terrasse couverte.",
      image: "/assets/photos/realisations/DSC06346.webp",
      alt: "Maison à étage aux menuiseries anthracite, garage accolé à toiture plate et jardin de façade planté derrière une clôture",
      tags: ["Primo-accédant", "Compacte", "Jardin"],
      agency: "Caissargues",
      surface: "95m²",
      year: "2024"
    },
    {
      id: 11,
      title: "Villa Familiale Bouillargues",
      description: "Grande maison familiale de 185m² avec 5 chambres, bureau et triple garage.",
      image: "/assets/photos/realisations/DSC06363.webp",
      alt: "Maison provençale à volets vert amande, muret en pierre sèche, oliviers et cyprès derrière un portail coulissant",
      tags: ["Familiale", "5 chambres", "Grand terrain"],
      agency: "Caissargues",
      surface: "185m²",
      year: "2022"
    },
    {
      id: 12,
      title: "Maison Bord de Mer Istres",
      description: "Villa de 165m² à 5 minutes de la mer, terrasse panoramique et jardin méditerranéen.",
      image: "/assets/photos/realisations/DSC06677.webp",
      alt: "Maison à étage en enduit crème avec deux garages, cour goudronnée et grand pin en arrière-plan",
      tags: ["Bord de mer", "Panoramique", "Terrasse"],
      agency: "Fos-sur-Mer",
      surface: "165m²",
      year: "2023"
    }
  ]
};
